import { NavigationButtons } from '@onegov/react-component-library';
import { Col, ErrorSummary, HorizontalRule, Row, SectionPage } from '@snsw/react-component-library';
import { PlantItemRenewalDeclarations } from 'plantItemRenewal/constants/plantItemRenewalDeclarations';
import {
  storePlantItemRenewalApplicantFullName,
  storePlantItemRenewalApplicantJobTitle,
} from 'plantItemRenewal/redux/plantItemRenewalApplicantDetailsSlice';
import {
  clearPlantItemRenewalDeclaration,
  storePlantItemRenewalDeclaration,
} from 'plantItemRenewal/redux/plantItemRenewalDeclarationSlice';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Declaration } from 'shared/components/declaration/Declaration';
import { PagePath } from 'shared/constants/pagePath';
import ScrollToTop from 'shared/utils/scrollToTop';
import { scrollToError } from 'shared/utils/Validation';

export const PlantItemRenewalDeclaration = () => {
  ScrollToTop();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const applicantState = useSelector((state) => state.plantItemRenewalApplicantDetails);
  const declarationState = useSelector((state) => state.plantItemRenewalDeclaration);
  const payment = useSelector((state) => state.plantItemRenewalPayment);

  const [declarationDetails, setDeclarationDetails] = useState({});
  const [showErrors, setShowErrors] = useState(false);
  const [errorSummary, setErrorSummary] = useState([]);

  const childRef = useRef();

  const warning = {
    title: (
      <>
        It is an offence under the <em>Crimes Act & section 268</em> of the <em>WHS Act</em> to make a false or
        misleading statement in this application.
      </>
    ),
    content: (
      <p>
        Making a false or misleading statement, giving false or misleading information, or producing false or misleading
        documents is a serious offence which may result in penalties including a fine or imprisonment.
      </p>
    ),
  };

  const onContinueClick = () => {
    const isValid = childRef.current.validate();
    setShowErrors(!isValid);
    if (isValid) {
      acceptDeclaration();
      navigate(PagePath.plantItemRenewalFees);
    } else {
      dispatch(clearPlantItemRenewalDeclaration());
      scrollToError();
    }
  };

  const acceptDeclaration = () => {
    dispatch(storePlantItemRenewalApplicantFullName(declarationDetails.fullName));
    dispatch(storePlantItemRenewalApplicantJobTitle(declarationDetails.jobTitle));
    dispatch(
      storePlantItemRenewalDeclaration({
        accepted: declarationDetails.accepted,
        stamp: declarationDetails.agreementStampText,
      }),
    );
  };

  return (
    <>
      <SectionPage>
        <Row>
          <Col span={8}>{showErrors && !!errorSummary?.length && <ErrorSummary errors={errorSummary} />}</Col>
        </Row>

        <Declaration
          ref={childRef}
          warning={warning}
          consent={PlantItemRenewalDeclarations.consent}
          fullName={applicantState?.fullName}
          isFullNameEditable={true}
          jobTitle={applicantState?.jobTitle}
          accepted={declarationState?.accepted}
          onChange={setDeclarationDetails}
          showErrors={showErrors}
          onErrorChange={setErrorSummary}
        />

        <HorizontalRule />

        <Row>
          <Col span={8}>
            <NavigationButtons
              leftButtonConfig={{
                label: 'Continue',
                onClick: onContinueClick,
                isVisible: !payment.paymentReference,
              }}
              rightButtonConfig={{
                isVisible: false,
              }}
              backButtonConfig={{
                onClick: () => navigate(PagePath.plantItemRenewalContactDetails),
                isVisible: !payment.paymentReference,
              }}
            />
          </Col>
        </Row>
      </SectionPage>
    </>
  );
};
